var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "alpheios-tab-options",
      attrs: { "data-alpheios-ignore": "all" },
    },
    [
      _c(
        "div",
        { staticClass: "alpheios-tab-options__optionscont" },
        [
          _c(
            "div",
            { staticClass: "alpheios-tab-options-switch" },
            [
              _c(
                "alph-tooltip",
                {
                  attrs: {
                    tooltipText: _vm.l10n.getText("OPTIONS_TAB_UI"),
                    tooltipDirection: "bottom-left",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "alpheios-tab-options-switch--item",
                      class: { "alpheios-active": _vm.currentTab === 1 },
                      on: {
                        click: function ($event) {
                          _vm.currentTab = 1
                        },
                      },
                    },
                    [_vm._v("UI")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "alph-tooltip",
                {
                  attrs: {
                    tooltipText: _vm.l10n.getText("OPTIONS_TAB_FEATURE"),
                    tooltipDirection: "bottom-left",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "alpheios-tab-options-switch--item",
                      class: { "alpheios-active": _vm.currentTab === 2 },
                      on: {
                        click: function ($event) {
                          _vm.currentTab = 2
                        },
                      },
                    },
                    [
                      _vm._v("F"),
                      _c(
                        "span",
                        {
                          staticClass:
                            "alpheios-tab-options-switch--item__smaller",
                        },
                        [_vm._v("eatures")]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "alph-tooltip",
                {
                  attrs: {
                    tooltipText: _vm.l10n.getText("OPTIONS_TAB_RESOURCE"),
                    tooltipDirection: "bottom-left",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "alpheios-tab-options-switch--item",
                      class: { "alpheios-active": _vm.currentTab === 3 },
                      on: {
                        click: function ($event) {
                          _vm.currentTab = 3
                        },
                      },
                    },
                    [
                      _vm._v("R"),
                      _c(
                        "span",
                        {
                          staticClass:
                            "alpheios-tab-options-switch--item__smaller",
                        },
                        [_vm._v("esources")]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "alph-tooltip",
                {
                  attrs: {
                    tooltipText: _vm.l10n.getText("OPTIONS_TAB_ADVANCED"),
                    tooltipDirection: "bottom-left",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "alpheios-tab-options-switch--item",
                      class: { "alpheios-active": _vm.currentTab === 4 },
                      on: {
                        click: function ($event) {
                          _vm.currentTab = 4
                        },
                      },
                    },
                    [
                      _vm._v("A"),
                      _c(
                        "span",
                        {
                          staticClass:
                            "alpheios-tab-options-switch--item__smaller",
                        },
                        [_vm._v("dvanced")]
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("ui-settings", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentTab === 1,
                expression: "currentTab === 1",
              },
            ],
            key: _vm.uiSettingsKey,
          }),
          _vm._v(" "),
          _c("feature-settings", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentTab === 2,
                expression: "currentTab === 2",
              },
            ],
            key: _vm.featureSettingsKey,
          }),
          _vm._v(" "),
          _c("resource-settings", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentTab === 3,
                expression: "currentTab === 3",
              },
            ],
            key: _vm.resourceSettingsKey,
          }),
          _vm._v(" "),
          _c("advanced-settings", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentTab === 4,
                expression: "currentTab === 4",
              },
            ],
            key: _vm.advancedSettingsKey,
          }),
          _vm._v(" "),
          _c("div", { staticClass: "alpheios-tab-options-reset-all-block" }, [
            _c(
              "button",
              {
                staticClass: "alpheios-button-primary",
                on: { click: _vm.resetAllOptions },
              },
              [
                _vm._v(
                  _vm._s(_vm.l10n.getText("LABEL_RESET_OPTIONS")) + "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "alpheios-tab-options-reset-all-block--title" },
              [
                _vm._v(
                  "(" +
                    _vm._s(_vm.l10n.getText("OPTIONS_TAB_RESET_ALL_TITLE")) +
                    ")"
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "alpheios-tab-options__aboutcont" }, [
        _c("h3", [_vm._v(_vm._s(_vm.l10n.getMsg("TEXT_INFO_ABOUT")))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "alpheios-info__versiontext alpheios-text__smallest" },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.app.name) +
                " " +
                _vm._s(_vm.app.version) +
                " " +
                _vm._s(_vm.buildNameForDisplay) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "alpheios-info__versiontext alpheios-text__smallest" },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.app.libName) +
                " " +
                _vm._s(_vm.app.libVersion) +
                " " +
                _vm._s(_vm.libBuildNameForDisplay) +
                "\n    "
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }